import { Injectable } from '@angular/core';
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {Item} from "../../models/Item";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {BehaviorSubject, combineLatest, empty, interval, Observable, of, pipe, ReplaySubject, Subject, timer} from 'rxjs';
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {debounceTime, map} from "rxjs/operators";
import {ServerConnectionService} from "../serverConnection/server-connection.service";
import {HintManagerService} from "../hintManager/hint-manager.service";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {concreteFigures} from "../../models/concreteFigures";
import {OverlayService} from "../overlay/overlay.service";
import {Overlay} from "../overlay/Overlay";
import {GlobalEventsService} from '../global-events.service';
import {GroupService} from "../groupService/group-service.service";
import {Group} from "../../classes/Groups/Group";
import {isBigEventOptimization} from "@src/configs/view_only";

declare const CONCRETE_LAYERS;
declare const Yiit;

@Injectable({
  providedIn: "root"
})
export class ConcreteLayerService {

  private ITEM_VISIBILITY_COMPONENT_NAME = 'ConcreteLayer';

  protected updateVisibleFloorplansInVisibleConfigTimer = null;
  protected _list: Map<number, ConcreteLayer> = new Map<number, ConcreteLayer>();
  protected _figures: Map<number, any> = concreteFigures;
  protected visibleConcreteLayer: ConcreteLayer = null;

  get currentVisibleConcreteLayer(){
    return this.visibleConcreteLayer;
  }
  // private prevGrayMode = null;
  // private listChanged$: ReplaySubject<any> = new ReplaySubject(1);
  private listChanged$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  get listChanged(){
    return this.listChanged$.asObservable();
  }
  public topLevelConcrete: ConcreteLayer = new ConcreteLayer('Outdoor');

  private prevSelectedItem = null;
  private concreteDrawing$:Subject<boolean> = new Subject<boolean>();
  private parentItemId$:BehaviorSubject<number> = new BehaviorSubject<number>(null);
  get onConcreteDrawing$(){
    return this.concreteDrawing$.asObservable();
  }
  get parentItemId() {
    return this.parentItemId$.asObservable();
  }

  private _selectedConcrete = null;

  get selectedConcrete(){
    return this._selectedConcrete;
  }

  set selectedConcrete(val: ConcreteHierarchyItemInterface){
    this._selectedConcrete = val;
  }

  private _onExpand$ = new Subject<string>()

  get onExpand$(){
    return this._onExpand$.asObservable();
  }



  constructor(
    private itemManagerService: ItemManagerService,
    private serverConnectionService: ServerConnectionService,
    private hintManagerService: HintManagerService,
    private uiAdapterService: UiAdapterService,
    private view: CesiumAdapterService,
    private overlayService: OverlayService,
    private eventService: GlobalEventsService,
    private groupsService: GroupService
  ) {
    this.registerConcreteHierarchyItem(this.topLevelConcrete);
    this.visibleConcreteLayer = this.topLevelConcrete;
    this.initListeners();
    this.groupsService.groupList.forEach((groupElement)=>{
      this.registerConcreteHierarchyItem(groupElement);
    });
  }

  getEnvironmentConfig(){
    console.error('getEnvironmentConfig', this.visibleConcreteLayer.asSimpleObject());
    return {overlay: this.visibleConcreteLayer.asSimpleObject()}
  }

  setEnvironmentConfig(config, active = true) {
    if (this._list.has(config.overlay.id)){
      let opacity = config.overlay.map_overlay_config.fillOpacity != null ? parseFloat(config.overlay.map_overlay_config.fillOpacity) : 1;
      this.show(this._list.get(config.overlay.id), opacity);
      this.overlayService.addToVisibleLayouts(this._list.get(config.overlay.id).overlay);
      this.view.setGrayScaleByConcrete(0);
      this.uiAdapterService.selectedConcrete$ = this._list.get(config.overlay.id);
      timer(1000).subscribe(()=>{
        let concrete = this._list.get(config.overlay.id);
        let opacity = config.overlay.map_overlay_config.fillOpacity != null ? parseFloat(config.overlay.map_overlay_config.fillOpacity) : 1;
        concrete.overlay.setOpacity(opacity);
        concrete.objectConfig.setFillOpacity(opacity);
      })
      // this.uiAdapterService.selectedItem$ = this._list.get(config.overlay.id);
    }
    if (config.overlay.id == null){
      // @ts-ignore
      this.show(this.getTopLevelCL());
      this.view.setGrayScaleByConcrete(1);
      this.uiAdapterService.selectedConcrete$ = this.getTopLevelCL();
      // this.uiAdapterService.selectedItem$ = this.getTopLevelCL();
    }
  }


  public combinedSubject = new BehaviorSubject([[],[],[]]);
  protected initListeners() {
    combineLatest(this.itemManagerService.itemsList, this.listChanged, this.groupsService.groupList$)
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.combinedSubject.next(data);
      });

    this.itemManagerService.itemAdded.subscribe((item)=>{
      // console.log('concrete itemAdded item', item);
      let concrete = this.uiAdapterService.currentSelectedItem;
      //
      if (!(concrete instanceof ConcreteLayer)){
        // @ts-ignore
        concrete = this.getParentConcrete(concrete);
        console.log('NOT concrete itemAdded concrete', concrete);
      }
      let parentConcrete = this.getParentConcrete(item);
      // console.log('item', item);
      // console.log('parent', parent);
      // console.log('concrete', concrete);
      // console.log('visibleConcrete', this.visibleConcreteLayer);
      if (parentConcrete && parentConcrete.getCHIId() != concrete.getCHIId()) {
        // console.log("ConcreteLayerService itemadded", parent.getCHIId(), concrete.getCHIId())
        item.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, false);
      } else {
        let parentConcreteId = item.getParentConcreteId();
        // console.log('parentConcreteId', parentConcreteId);
        if (parentConcreteId == this.visibleConcreteLayer.id) {
          item.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, true);
          // console.log("ConcreteLayerService itemadded visible")
        } else {
          console.log("ConcreteLayerService itemadded hidden")
        }
      }
    });
    this.groupsService.addedToGroupList$.subscribe((groupElement) => {
      this.registerConcreteHierarchyItem(groupElement);
      const concrete: ConcreteLayer | ConcreteHierarchyItemInterface = (groupElement.getFloorPlanId())
        ? this._list.get(groupElement.getFloorPlanId())
        : this.getTopLevelCL();
      // console.log('[TEST] group element', groupElement, concrete);
      this._onExpand$.next(concrete.id);
    });

    this.itemManagerService.on(ItemManagerService.BEFORE_ITEM_ADD, (item: Item, cb?) => {
      if (this.uiAdapterService.currentSelectedItem) {
        if (this.uiAdapterService.currentSelectedItem instanceof ConcreteLayer) {
          item.config.setConcreteLayerId(this.uiAdapterService.currentSelectedItem.id);
        } else if (this.uiAdapterService.currentSelectedItem instanceof Item) {
          let parent: ConcreteHierarchyItemInterface = this.getParent(this.uiAdapterService.currentSelectedItem);
          if (parent instanceof ConcreteLayer) {
            item.config.setConcreteLayerId(parent.id);
          }
          else{
            let concrete: ConcreteHierarchyItemInterface = this.getParentConcrete(this.uiAdapterService.currentSelectedItem);
            item.config.setConcreteLayerId(concrete.id)
          }
        }
        if (cb){
          return cb();
        }
        return;
      }

      if (this._selectedConcrete){
        item.config.setConcreteLayerId(this._selectedConcrete.id)
      }

      if (cb){
        return cb();
      }
    });

    this.view.editStart.subscribe((entityId)=>{
      this._figures.forEach((val, key)=>{
        if (val[0] == entityId){
          this.view.setVisibility(val[1], false);
          this.view.editPolygon({entityId:entityId, color: '#fff'}, (entity, positions)=>{
            if (this._list.has(key)){
              let concrete = this._list.get(key);
              concrete.objectConfig.setPositions(positions);
              this.serverConnectionService.updateConcreteItem(concrete.asSimpleObject());
            }
            this.view.updateBorderPath(positions, val[1], ()=>{
              this.view.setVisibility(val[1], true);
            });
          })
        }
      })
    });

    this.uiAdapterService.selectedItem$.subscribe((item: ConcreteHierarchyItemInterface) => {
      if (item) {
        let concrete: ConcreteLayer = null;
        if (item instanceof ConcreteLayer) {
          concrete = item;
          if (concrete.id != null){
            this.view.setGrayScaleByConcrete(0);
          }
          let isFirstZoom = true;
          if (this.prevSelectedItem && this.prevSelectedItem.hasOwnProperty('id') && this.prevSelectedItem.id && this.prevSelectedItem instanceof ConcreteLayer){
            isFirstZoom = false;
          }
          if (item.id) {
            this.centerOnConcrete(concrete, isFirstZoom);
          }
        } else if (item instanceof Item) {
          concrete = this.getParentConcrete(item) as ConcreteLayer;
          if (concrete && concrete.id == null) {
            this.view.setGrayScaleByConcrete(1);
            // this.prevGrayMode = null;
          }
          // item.centerOnObj();
        }

        if (item instanceof Item){
          this._selectedConcrete = concrete;
        }


        if (concrete.id == null) {
          this.view.setGrayScaleByConcrete(1);
          // this.prevGrayMode = null;
        }

        this.show(concrete);
         this.parentItemId$.next(concrete.parentItemId);
      }
      //now using only for logs
      this.prevSelectedItem = item;
    });

    this.overlayService.getFloorLayouts().subscribe((overlays: Overlay[]) => {
      overlays.forEach((overlay: Overlay) => {
          let concrete = ConcreteLayer.fromOverlay(overlay);
          this.registerConcreteLayer(concrete);
          this.hide(concrete);
      });
    });

    this.view.adapterInitialized.subscribe((status) => {
      if (status) {
        this.loadConcreteLayers();

        // this.overlayService.overlaySubject.subscribe((overlays: Overlay[]) => {
        //   overlays.forEach((overlay: Overlay) => {
        //     let concrete = ConcreteLayer.fromOverlay(overlay);
        //     this.registerConcreteLayer(concrete);
        //     this.hide(concrete);
        //   });
        // });
      }
    });

    if (isBigEventOptimization) {
      this.groupsService.itemsLoaded$.subscribe(_ => {
        console.log('register queue', this.registerQueue.length);
        const queue = this.registerQueue.slice();
        this.registerQueue.length = 0;
        queue.forEach(q => this.registerConcreteHierarchyItem(q));
        timer(10000).subscribe(_ => {
          this.eventService.ToastNotificationEvent.emit({
            autoHide: false,
            message: "Load completed",
            title: 'Loaded',
            classes: ['notification']
          });
        });
      });
    }

    // this.eventService.UpdatedObjectEvent.subscribe((config: ItemConfig) => {
    //   if (config.getConcreteLayerId()) {
    //     const concrete = this._list.get(config.getConcreteLayerId());
    //     this.hide(this.visibleConcreteLayer);
    //     this.visibleConcreteLayer = concrete;
    //     if (concrete.isOverlay) {
    //       concrete.overlay.setOpacity(1);
    //       concrete.overlay.show();
    //     }
    //     this.getConcreteHierarchyChildren(concrete).forEach((i) => {
    //       if (i instanceof Item) {
    //         i.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, true);
    //       }
    //     });
    //   }
    // });
  }

  centerOnConcrete(concrete, isFirstZoom?){
    if (!concrete.id){
      return;
    }
    let rectangleView = concrete.getRectangleView();
    if (rectangleView){
      this.view.centerOnConcreteLayout(rectangleView, isFirstZoom);
    }
  }

  protected loadConcreteLayers() {
    setTimeout(() => {
      CONCRETE_LAYERS.forEach((layerConfig) => {
        let cl = ConcreteLayer.fromConfig(layerConfig);
        this.registerConcreteLayer(cl);
      })
    }, 1);
  }

  public registerConcreteLayer(concreteLayer: ConcreteLayer, isDrawn?) {
    this.registerConcreteHierarchyItem(concreteLayer);
    this._list.set(concreteLayer.id, concreteLayer);

    if (concreteLayer.isOverlay) {
      // if (isDrawn) {
      //   this.show(concreteLayer);
      // } else {
      //   this.hide(concreteLayer);
      // }
    } else {
      // this.view.drawConcreteLayer(concreteLayer, (entityIds) => {
      //   this._figures.set(concreteLayer.id, entityIds);
      //   this.updateConcreteOptions(concreteLayer);
      //   (isDrawn) ? this.show(concreteLayer) : this.hide(concreteLayer);
      // });
    }

    this.listChanged$.next([].concat([], this.getCurrentList()));

    concreteLayer.objectConfig.subject.subscribe((config)=>{
      this.saveConcreteLayer(concreteLayer);
    })
  }

  public getParent(i:ConcreteHierarchyItemInterface){
    let parentItemId = null;
    let parentConcreteId = null;
    let parentGroupId = null;

    if (i){
      parentItemId = i.getParentItemId();
      parentConcreteId = i.getParentConcreteId();
      parentGroupId = i.getParentGroupId();
    }

    if (parentGroupId){
      return this.groupsService.getGroupById(parentGroupId);
    }

    if (parentItemId){
      return this.itemManagerService.getItemById(parentItemId);
    }

    if (parentConcreteId === null){
      return this.getTopLevelCL();
    }
    return this._list.get(parentConcreteId);
  }

  getFloorplanById(concreteId){
    if (concreteId === null){
      return this.getTopLevelCL();
    }

    return this._list.get(concreteId);
  }

  getParentConcrete(i: ConcreteHierarchyItemInterface){
    let parentItemId = null;
    let parentConcreteId = null;
    let parentGroupId = null;

    if (i){
      parentItemId = i.getParentItemId();
      parentConcreteId = i.getParentConcreteId();
      parentGroupId = i.getParentGroupId()
    }

    if (parentGroupId && i instanceof Group){
      let group = this.groupsService.getGroupById(parentGroupId);
      return this.getParentConcrete(group);
    }

    if (parentConcreteId === null){
      return this.getTopLevelCL();
    }

    return this._list.get(parentConcreteId);
  }

  private isFilterItem(i, item){
    let parent = this.getParent(i);
    if (parent && parent.getCHIId() == item.getCHIId()) {
      return true
    }
    return false
  }

  public registerQueue = [];
  public registerConcreteHierarchyItem(item: ConcreteHierarchyItemInterface) {
    if (!this.groupsService.itemsLoadedVal && isBigEventOptimization) {
      this.registerQueue.push(item);
      return;
    }
    // new Observable<ConcreteHierarchyItemInterface[]>
    // item - parent item, i - child items
    item.setChildren(
      this.combinedSubject
      // combineLatest(this.itemManagerService.itemsList, this.listChanged, this.groupsService.groupList$)
      //   .pipe(debounceTime(500))
        .pipe(
        map((data) => {
          const items: ConcreteHierarchyItemInterface[] = Object.values(data[0]);
          let filteredItems = items.filter((i) => {
            return this.isFilterItem(i, item);
          });
          const secondItems: ConcreteHierarchyItemInterface[] = data[1];
          filteredItems = filteredItems.concat(secondItems.filter((i: ConcreteHierarchyItemInterface) => {
            return this.isFilterItem(i, item);
          }));
          const thirdItems: ConcreteHierarchyItemInterface[] = data[2];
          filteredItems = filteredItems.concat(thirdItems.filter((i: ConcreteHierarchyItemInterface) => {
            return this.isFilterItem(i, item);
          }));
          if (item instanceof Group) {
          }
          return filteredItems;
        })
      )
    );

    // if (title == 'Workforce') {
    //   console.log('[TEST] WF item', item)
    // }

  }

  public getTopLevelCL(): ConcreteHierarchyItemInterface {
    return this.topLevelConcrete;
  }

  public assignConcreteHierarchyItem(
    item: ConcreteHierarchyItemInterface,
    concreteLayerId: number,
    oldConcreteLayerId?: number
  ) {
    if (!this._list.has(concreteLayerId)) {
      throw new Error("Target concrete layer not found: " + concreteLayerId);
    }
    let oldParent = this.getTopLevelCL();
    if (oldConcreteLayerId) {
      if (!this._list.has(oldConcreteLayerId)) {
        throw new Error("Source concrete layer not found: " + concreteLayerId);
      }
      oldParent = this._list.get(oldConcreteLayerId);
    }
    oldParent.removeChild(item);

    let parent = this._list.get(concreteLayerId);
    parent.addChild(item);
  }

  public getConcreteHierarchyChildren(item: ConcreteHierarchyItemInterface): ConcreteHierarchyItemInterface[] {
    if (item instanceof Item) {
      return this.getItemChildren(item);
    } else if (item instanceof ConcreteLayer) {
      return this.getConcreteLayerChildren(item);
    }
  }

  public getItemChildren(item: Item): ConcreteHierarchyItemInterface[] {
    let children = [];
    this.forEach((i: ConcreteLayer) => {
      if (i.parentItemId === item.getId()) {
        children.push(i);
      }
    });
    return children;
  }

  public getConcreteLayerChildren(item: ConcreteLayer): ConcreteHierarchyItemInterface[] {
    let children = [];
    this.forEach((i: ConcreteLayer) => {
      if (i.parentItemId === null && i.parentConcreteId === item.id) {
        children.push(i);
      }
    });
    this.itemManagerService.forEach((i: Item) => {
      if (i.config.getConcreteLayerId() === item.id) {
        children.push(i);
      }
    });

    return children;
  }

  getCurrentList(){
    let concreteArr = [];
    this.forEach((item: ConcreteLayer) => {
      concreteArr.push(item);
    });
    return concreteArr;
  }

  public forEach(cb: CallableFunction) {
    // @ts-ignore
    this._list.forEach(cb);
  }

  private updateListChanged(){
    this.listChanged$.next(this.getCurrentList());
  }

  public saveConcreteLayer(item: ConcreteLayer, cb?): void {
    if (item.isOverlay) {
      console.warn("Ignore saving overlay as concrete layer");
      return;
    }
    if (item.id) {
      this.serverConnectionService.updateConcreteItem(item.asSimpleObject(), (item)=>{
        this.updateListChanged();
        if (cb)cb(item)
      });
    } else {
      this.serverConnectionService.addConcreteItem(
        item.asSimpleObject(),
        (newConcreteLayerConfig) => {
          item.updateFromConfig(newConcreteLayerConfig);
          if (cb) {
            cb(item);
          }
        }
      )
    }
  }

  public removeConcreteLayer(item: ConcreteLayer, cb?): void {
    if (item.isOverlay) {
      console.warn("Ignore removing overlay as concrete layer");
      return;
    }
    if (item.id) {
      this.serverConnectionService.removeConcreteItem({id:item.id}, (res)=>{
        if (res){
          if (this._figures.has(item.id)){
            if (Array.isArray(this._figures.get(item.id))){
              this._figures.get(item.id).forEach((itemId)=>{
                this.view.removeObject(itemId);
              })
            }
            else{
              this.view.removeObject(this._figures.get(item.id));
            }
            this._figures.delete(item.id);
          }
          this.uiAdapterService.selectedItem$ = this.topLevelConcrete;
          this._list.delete(item.id);
          this.updateListChanged();
          if (cb) cb(res)
        }
      });
    }
  }


  public uploadConcreteLayerImage(item: ConcreteLayer, file: File, cb?) {
    if (item.isOverlay) {
      console.warn("Ignore image upload for overlay as concrete layer");
      return;
    }
    if (item.id) {
      let reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        this.serverConnectionService.updateConcreteItemImage(
          {object_id: item.id, name: file.name, data: reader.result},
          (fileUrl) => {
            item.setBgImageUrl(fileUrl);
            this.updateConcreteOptions(item);
            if (cb) { cb(fileUrl); }
          });
      };

      reader.onerror = function() {
        console.error(reader.error);
      };
    }
  }

  public updateConcreteOptions(concrete:ConcreteLayer){
    if (this._figures.has(concrete.id)){
      let figureId = this._figures.get(concrete.id)[0];
      if (figureId){
        this.view.setConcreteMaterial(figureId, concrete.bgImageUrl, concrete.objectConfig.getFillOpacity());
      }
    }
  }

  public drawConcreteLayer(title?: string|ConcreteLayer, cb?) {
    if (title instanceof ConcreteLayer) {
      if (!title.getTitle()) {
        title.title = window.prompt(Yiit.t('Floor layout name'));
      }
      if (!title.getTitle()) {
        if (cb) {
          cb(null, "Title is required");
        }
        return false;
      }
    } else {
      if (!title) {
        title = window.prompt(Yiit.t('Floor layout name'));
      }
      if (!title) {
        if (cb) {
          cb(null, "Title is required");
        }
        return false;
      }
    }

    this.hintManagerService.isTimeoutHint = false;
    this.hintManagerService.textColor = '#fb5915';
    this.hintManagerService.hintText = "Click on each point around the area you want to choose, double click to finish";

    // let items = this.itemManagerService.getAllItems();

    if (!(title instanceof ConcreteLayer)) {
      if (this.uiAdapterService.currentSelectedItem instanceof Item) {
        this.parentItemId$.next(this.uiAdapterService.currentSelectedItem.getId());
      }
    }

    // setObjectsGrayscale(true);
    this.concreteDrawing$.next(true);
    // @ts-ignore
    this.view.startDrawingConcrete((positions) => {
      this.hintManagerService.hintText = null;
      if (positions.length > 2) {
        let cl: ConcreteLayer;
        if (title instanceof ConcreteLayer) {
          cl = title;
        } else {
          cl = new ConcreteLayer(title);
          if (this.uiAdapterService.currentSelectedItem) {
            if (this.uiAdapterService.currentSelectedItem instanceof ConcreteLayer) {
              cl.parentConcreteId = this.uiAdapterService.currentSelectedItem.id;
            } else if (this.uiAdapterService.currentSelectedItem instanceof Item) {
              cl.parentItemId = this.uiAdapterService.currentSelectedItem.getId();
            }
          }
        }
        cl.setPositions(positions);
        this.saveConcreteLayer(cl, (item)=>{
          this.registerConcreteLayer(item, true);
          // this.concreteDrawing$.next(false);
      //     if (cb) {cb(item)}
        });
      } else {
        if (cb) {
          cb(null, "At least 3 positions are required");
        }
      }
      this.hintManagerService.clearHint();
    });
  }
  public showById(floorplanId){
    let concrete = this._list.get(floorplanId);
    this.show(concrete);
  }

  public show(item: ConcreteLayer, opacity?) {
    if (this.visibleConcreteLayer && this.visibleConcreteLayer.getCHIId() === item.getCHIId()) {
      return;
    }
    this.hide(this.visibleConcreteLayer);
    this.visibleConcreteLayer = item;
    if (this._figures.has(item.id)) {
      this.view.showConcreteLayer(this._figures.get(item.id))
    }
    if (item.isOverlay) {
      let _opacity = (opacity != undefined) ? opacity : 1;
      item.overlay.setOpacity(_opacity);
      item.overlay.isVisible = true;
      item.overlay.show();
      this.view.selectedOverlay = item.overlay;
    } else {
      this.view.selectedOverlay = null;
    }
    this.getConcreteHierarchyChildren(item).forEach((i) => {
      if (i instanceof Item) {
        i.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, true);
      }
    });
  }

  public hideAllConcrete(): void {

  }

  public hide(item: ConcreteLayer) {
    if (this._figures.has(item.id)) {
      this.view.hideConcreteLayer(this._figures.get(item.id))
    }
    if (item.isOverlay) {
      item.overlay.setOpacity(0);
      item.overlay.hide();
    }
    this.getConcreteHierarchyChildren(item).forEach((i) => {
      if (i instanceof Item) {
        i.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, false);
      }
    });
  }
}
